import React, { useEffect } from "react";
import { GoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Card,
  CardContent,
  Typography,
  Box,
  Divider
} from "@mui/material";

const Login = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("token")) {
      navigate("/dashboard", { replace: true });
    }
  }, [navigate]);

  const handleSuccess = async (credentialResponse) => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5000"; 

    const res = await axios.post(`${apiUrl}/api/login`, {
      credential: credentialResponse.credential,
    });

      localStorage.setItem("token", res.data.token);
      localStorage.setItem("user", JSON.stringify(res.data.user));
      navigate("/dashboard");
    } catch (err) {
      console.error("Login failed:", err);
    }
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Card sx={{ p: 4, borderRadius: 3, boxShadow: 6, width: "100%" }}>
        <CardContent sx={{ textAlign: "center" }}>
          <Box sx={{ mb: 3 }}>
            <img
              src="/navriti-logo.png"
              alt="Navriti Logo"
              style={{ width: "160px", objectFit: "contain" }}
            />
          </Box>
          <Typography variant="h5" gutterBottom>
            Welcome to Navriti
          </Typography>
          <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
            Sign in with your Google account to continue.
          </Typography>
          <Divider sx={{ mb: 3 }} />
          <Box display="flex" justifyContent="center">
            <GoogleLogin
              onSuccess={handleSuccess}
              onError={() => console.log("Login Failed")}
            />
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
};

export default Login;
